import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  description: {
    fontSize: "16px",
    color: "#6b7280",
    margin: 0,
    lineHeight: 1.4,
  },
}));

/**
 * Pre-styled description text for use inside a DialogHeader or DialogBody.
 * Useful for providing secondary context below a DialogTitle.
 *
 * @param {string} className - Additional class name
 */
const DialogDescription = ({ className = "", children, ...rest }) => {
  const classes = useStyles();

  return (
    <p className={`${classes.description} ${className}`} {...rest}>
      {children}
    </p>
  );
};

export default DialogDescription;
